import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import AppMenu from './AppMenu';
import AppMenuFavorites from './AppMenuFavorites';
import { LayoutContext } from './context/layoutcontext';
import { MenuProvider } from './context/menucontext';
import { useMenuCategory } from '../contexts/MenuCategoryContext';
import { useLanguage } from '../contexts/LanguageContext';

const AppSidebar = (props) => {
    const { setLayoutState, layoutState, onMenuToggle, isDesktop } = useContext(LayoutContext);
    const { selectedCategory, setSelectedCategory } = useMenuCategory();
    const { th } = useLanguage();
    const navigate = useNavigate();
    const location = useLocation();
    let timeout = null;

    const anchor = () => {
        setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            anchored: !prevLayoutState.anchored
        }));
    };

    const onMouseEnter = () => {
        if (!layoutState.anchored) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                sidebarActive: true
            }));
        }
    };

    const onMouseLeave = () => {
        if (!layoutState.anchored) {
            if (!timeout) {
                timeout = setTimeout(() => {
                    setLayoutState((prevLayoutState) => ({
                        ...prevLayoutState,
                        sidebarActive: false
                    }));
                }, 300);
            }
        }
    };

    const navigateToDashboard = () => {
        setSelectedCategory(null);
        if (location.pathname === '/') {
            // Zaten ana sayfadaysak, state update yeterli (MenuCategory useEffect'i tetikleyecek)
            return;
        }
        navigate('/');
    };

    const handleHomeMenuClick = () => {
        // Önce state'i resetle
        setSelectedCategory(null);

        // Eğer zaten ana sayfadaysak, zorla yeniden render için state ile navigate et
        if (location.pathname === '/') {
            // State güncellemesi MenuCategory'deki useEffect'i tetikleyecek
            navigate('/', { replace: true, state: { refresh: Date.now() } });
        } else {
            navigate('/');
        }
    };

    const handleCloseMenu = () => {
        if (!isDesktop()) {
            onMenuToggle();
        }
    };

    return (
        <React.Fragment>
            <div ref={props.sidebarRef} className="layout-sidebar" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <div className="sidebar-header">
                    {!isDesktop() && (
                        <button 
                            type="button" 
                            className="sidebar-close-button p-link" 
                            onClick={handleCloseMenu}
                            aria-label="Menüyü Kapat"
                        >
                            <i className="pi pi-times"></i>
                        </button>
                    )}
                    <a onClick={navigateToDashboard} className="app-logo cursor-pointer">
                        <img 
                            src="/logobeyaz.png" 
                            alt="Karsan Logo" 
                            className="app-logo-normal"
                            style={{ height: '2rem', width: 'auto' }}
                        />
                        <img 
                            src="/logobeyaz.png" 
                            alt="Karsan Logo" 
                            className="app-logo-single h-2rem"
                            style={{ display: 'none', height: '2rem', width: 'auto' }}
                        />
                    </a>
                    <button className="layout-sidebar-anchor p-link" type="button" onClick={anchor}></button>
                </div>

                {/* Ana Menü Butonu - Sadece kategori seçiliyken göster */}
                {selectedCategory && (
                    <>
                        <div className="home-menu-button-container">
                            <Button label={th('menu.mainMenu', { fallback: 'Ana Menü' })} icon="pi pi-home" className="w-full home-menu-button" onClick={handleHomeMenuClick} tooltipOptions={{ position: 'right' }} />
                        </div>
                        <Tooltip target=".home-menu-button" />
                    </>
                )}

                <div className="layout-menu-container">
                    <AppMenuFavorites />
                    <MenuProvider>
                        <AppMenu />
                    </MenuProvider>
                </div>
            </div>
        </React.Fragment>
    );
};

AppSidebar.displayName = 'AppSidebar';

export default AppSidebar;
